import { Dayjs } from 'dayjs';
import { LOCAL_DATE_FORMAT } from '@lib/env';

export class DemandMetadataChangeRequest {
    public validUntil: string;

    constructor(
        public readonly title: string,
        public readonly messageToSupplier: string,
        public readonly internalMessage: string,
        public readonly conditions: string,
        validUntil?: Dayjs
    ) {
        if (validUntil && validUntil.isValid()) {
            this.validUntil = validUntil.format(LOCAL_DATE_FORMAT);
        } else {
            this.validUntil = '';
        }
    }
}
